import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { expireCoupaFilesById } from "../../service/expireCoupaFilesById";
import {
  expireCoupaFilesSuccess,
  expireCoupaFilesFailure,
} from "../reducers/drmCoupaExpireSlice";

export function* workerExpireCoupaFiles({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(expireCoupaFilesById, [payload, controller]);
    const detailsRoot = response?.data?.details;
    const detailsData = detailsRoot?.data;
    const details =
      (detailsData && typeof detailsData === "object" ? detailsData : detailsRoot) ||
      {};

    const toArray = (records) => (Array.isArray(records) ? records : []);

    const summaryList  = toArray(details?.summaryList);
    

    const formatRecordMessages = (records = []) => {
      if (!records.length) {
        return "";
      }

      const formattedRows = records
        .map((record, index) => {
          const coupaFileId = record?.coupaFileId ?? `Row-${index + 1}`;
          const result = record?.result ?? "";
          const reason = record?.reason ?? "No reason provided";
          return `${index + 1}. Coupa File ID: ${coupaFileId} - ${result} - ${reason}`;
        })
        .join("\n");

      return formattedRows;
    };

    const responseMessage = response?.data?.message;
    const messageSegments = [
      formatRecordMessages(summaryList),
    ].filter(Boolean);

    const combinedPayload = messageSegments.join("\n\n") || responseMessage;

    yield put(expireCoupaFilesSuccess(combinedPayload));
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Unable to expire Coupa files.";
    yield put(expireCoupaFilesFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmCoupaExpireSaga() {
  yield takeLatest("drmCoupaExpire/expireCoupaFilesStart", workerExpireCoupaFiles);
}

export default drmCoupaExpireSaga;
